<template>
    <transition
        name="unpin-slide"
        @after-leave="afterLeave"
      >
      <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.allergy, collapsed: !expanded.allergy }">
          <div class="info-card-content">
          <!-- Collapsed state -->
          <div v-if="!expanded.allergy" class="collapsed-content">
            <div class="info-row">
              <div class="icon-container">
                <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 12C9.36667 12 8.75417 11.9125 8.1625 11.7375C7.57083 11.5625 7.025 11.3083 6.525 10.975C5.79167 10.925 5.04167 10.7667 4.275 10.5C3.50833 10.2333 2.80833 9.79167 2.175 9.175C1.54167 8.55833 1.02083 7.75 0.6125 6.75C0.204167 5.75 0 4.5 0 3V2.5C0 1.8 0.241667 1.20833 0.725 0.725C1.20833 0.241667 1.8 0 2.5 0C3.15 0 3.7125 0.225 4.1875 0.675C4.6625 1.125 4.925 1.66667 4.975 2.3C5.44167 2.16667 5.85833 2 6.225 1.8C6.59167 1.6 6.96667 1.40833 7.35 1.225C7.73333 1.025 8.13333 0.854167 8.55 0.7125C8.96667 0.570833 9.45 0.5 10 0.5C10.5667 0.5 11.0542 0.570833 11.4625 0.7125C11.8708 0.854167 12.2667 1.025 12.65 1.225C13.0167 1.40833 13.3875 1.6 13.7625 1.8C14.1375 2 14.5583 2.16667 15.025 2.3C15.075 1.65 15.3375 1.10417 15.8125 0.6625C16.2875 0.220833 16.85 0 17.5 0C18.2 0 18.7917 0.241667 19.275 0.725C19.7583 1.20833 20 1.8 20 2.5V3C20 4.5 19.7958 5.75 19.3875 6.75C18.9792 7.75 18.4583 8.55833 17.825 9.175C17.1917 9.79167 16.4917 10.2333 15.725 10.5C14.9583 10.7667 14.2083 10.925 13.475 10.975C12.975 11.3083 12.4292 11.5625 11.8375 11.7375C11.2458 11.9125 10.6333 12 10 12ZM4.5 8.975C4.18333 8.475 3.9375 7.92917 3.7625 7.3375C3.5875 6.74583 3.5 6.13333 3.5 5.5V2.5C3.5 2.21667 3.40417 1.97917 3.2125 1.7875C3.02083 1.59583 2.78333 1.5 2.5 1.5C2.21667 1.5 1.97917 1.59583 1.7875 1.7875C1.59583 1.97917 1.5 2.21667 1.5 2.5V3C1.5 4.83333 1.80833 6.2 2.425 7.1C3.04167 8 3.73333 8.625 4.5 8.975ZM10 10.5C11.3833 10.5 12.5625 10.0125 13.5375 9.0375C14.5125 8.0625 15 6.88333 15 5.5V3.85C14.4333 3.71667 13.9375 3.55833 13.5125 3.375C13.0875 3.19167 12.7 2.99167 12.35 2.775C11.8833 2.49167 11.4708 2.29167 11.1125 2.175C10.7542 2.05833 10.3833 2 10 2C9.61667 2 9.24583 2.05833 8.8875 2.175C8.52917 2.29167 8.11667 2.49167 7.65 2.775C7.3 2.975 6.9125 3.175 6.4875 3.375C6.0625 3.575 5.56667 3.73333 5 3.85V5.5C5 6.88333 5.4875 8.0625 6.4625 9.0375C7.4375 10.0125 8.61667 10.5 10 10.5ZM7 5.25C7.36667 5.15 7.68333 5.02917 7.95 4.8875C8.21667 4.74583 8.46667 4.60833 8.7 4.475C8.93333 4.34167 9.14583 4.22917 9.3375 4.1375C9.52917 4.04583 9.75 4 10 4C10.25 4 10.4708 4.04583 10.6625 4.1375C10.8542 4.22917 11.0667 4.34167 11.3 4.475C11.5333 4.60833 11.7792 4.74583 12.0375 4.8875C12.2958 5.02917 12.6167 5.15 13 5.25V4.2C12.75 4.11667 12.5333 4.025 12.35 3.925L11.8 3.625C11.5333 3.45833 11.2625 3.3125 10.9875 3.1875C10.7125 3.0625 10.3833 3 10 3C9.61667 3 9.2875 3.0625 9.0125 3.1875C8.7375 3.3125 8.45833 3.45833 8.175 3.625L7.625 3.925C7.44167 4.025 7.23333 4.11667 7 4.2V5.25ZM15.5 8.975C16.2667 8.625 16.9583 8 17.575 7.1C18.1917 6.2 18.5 4.83333 18.5 3V2.5C18.5 2.21667 18.4042 1.97917 18.2125 1.7875C18.0208 1.59583 17.7833 1.5 17.5 1.5C17.2167 1.5 16.9792 1.59583 16.7875 1.7875C16.5958 1.97917 16.5 2.21667 16.5 2.5V5.5C16.5 6.13333 16.4167 6.74583 16.25 7.3375C16.0833 7.92917 15.8333 8.475 15.5 8.975Z" fill="#25B8C2"/>
                </svg>
              </div>
              <p class="info-text-title">Allergy:</p>
              <div class="flex flex-row items-center gap-2 ml-auto">
                <div @click.stop="toggleCard('allergy')" class="action-icon">
                  <img src="@/assets/cardActions/expand.svg" alt="Expand" />
                </div>
                <div class="drag-handle action-icon">
                  <img src="@/assets/cardActions/move.svg" alt="Move" />
                </div>
              </div>
            </div>
          </div>

          <!-- Expanded state -->
          <div v-else class="allergy-card-expanded">
            <!-- Header row: icon + title + pin -->
            <div class="allergy-header">
              <div class="icon-container">
                <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 12C9.36667 12 8.75417 11.9125 8.1625 11.7375C7.57083 11.5625 7.025 11.3083 6.525 10.975C5.79167 10.925 5.04167 10.7667 4.275 10.5C3.50833 10.2333 2.80833 9.79167 2.175 9.175C1.54167 8.55833 1.02083 7.75 0.6125 6.75C0.204167 5.75 0 4.5 0 3V2.5C0 1.8 0.241667 1.20833 0.725 0.725C1.20833 0.241667 1.8 0 2.5 0C3.15 0 3.7125 0.225 4.1875 0.675C4.6625 1.125 4.925 1.66667 4.975 2.3C5.44167 2.16667 5.85833 2 6.225 1.8C6.59167 1.6 6.96667 1.40833 7.35 1.225C7.73333 1.025 8.13333 0.854167 8.55 0.7125C8.96667 0.570833 9.45 0.5 10 0.5C10.5667 0.5 11.0542 0.570833 11.4625 0.7125C11.8708 0.854167 12.2667 1.025 12.65 1.225C13.0167 1.40833 13.3875 1.6 13.7625 1.8C14.1375 2 14.5583 2.16667 15.025 2.3C15.075 1.65 15.3375 1.10417 15.8125 0.6625C16.2875 0.220833 16.85 0 17.5 0C18.2 0 18.7917 0.241667 19.275 0.725C19.7583 1.20833 20 1.8 20 2.5V3C20 4.5 19.7958 5.75 19.3875 6.75C18.9792 7.75 18.4583 8.55833 17.825 9.175C17.1917 9.79167 16.4917 10.2333 15.725 10.5C14.9583 10.7667 14.2083 10.925 13.475 10.975C12.975 11.3083 12.4292 11.5625 11.8375 11.7375C11.2458 11.9125 10.6333 12 10 12ZM4.5 8.975C4.18333 8.475 3.9375 7.92917 3.7625 7.3375C3.5875 6.74583 3.5 6.13333 3.5 5.5V2.5C3.5 2.21667 3.40417 1.97917 3.2125 1.7875C3.02083 1.59583 2.78333 1.5 2.5 1.5C2.21667 1.5 1.97917 1.59583 1.7875 1.7875C1.59583 1.97917 1.5 2.21667 1.5 2.5V3C1.5 4.83333 1.80833 6.2 2.425 7.1C3.04167 8 3.73333 8.625 4.5 8.975ZM10 10.5C11.3833 10.5 12.5625 10.0125 13.5375 9.0375C14.5125 8.0625 15 6.88333 15 5.5V3.85C14.4333 3.71667 13.9375 3.55833 13.5125 3.375C13.0875 3.19167 12.7 2.99167 12.35 2.775C11.8833 2.49167 11.4708 2.29167 11.1125 2.175C10.7542 2.05833 10.3833 2 10 2C9.61667 2 9.24583 2.05833 8.8875 2.175C8.52917 2.29167 8.11667 2.49167 7.65 2.775C7.3 2.975 6.9125 3.175 6.4875 3.375C6.0625 3.575 5.56667 3.73333 5 3.85V5.5C5 6.88333 5.4875 8.0625 6.4625 9.0375C7.4375 10.0125 8.61667 10.5 10 10.5ZM7 5.25C7.36667 5.15 7.68333 5.02917 7.95 4.8875C8.21667 4.74583 8.46667 4.60833 8.7 4.475C8.93333 4.34167 9.14583 4.22917 9.3375 4.1375C9.52917 4.04583 9.75 4 10 4C10.25 4 10.4708 4.04583 10.6625 4.1375C10.8542 4.22917 11.0667 4.34167 11.3 4.475C11.5333 4.60833 11.7792 4.74583 12.0375 4.8875C12.2958 5.02917 12.6167 5.15 13 5.25V4.2C12.75 4.11667 12.5333 4.025 12.35 3.925L11.8 3.625C11.5333 3.45833 11.2625 3.3125 10.9875 3.1875C10.7125 3.0625 10.3833 3 10 3C9.61667 3 9.2875 3.0625 9.0125 3.1875C8.7375 3.3125 8.45833 3.45833 8.175 3.625L7.625 3.925C7.44167 4.025 7.23333 4.11667 7 4.2V5.25ZM15.5 8.975C16.2667 8.625 16.9583 8 17.575 7.1C18.1917 6.2 18.5 4.83333 18.5 3V2.5C18.5 2.21667 18.4042 1.97917 18.2125 1.7875C18.0208 1.59583 17.7833 1.5 17.5 1.5C17.2167 1.5 16.9792 1.59583 16.7875 1.7875C16.5958 1.97917 16.5 2.21667 16.5 2.5V5.5C16.5 6.13333 16.4167 6.74583 16.25 7.3375C16.0833 7.92917 15.8333 8.475 15.5 8.975Z" fill="#25B8C2"/>
                </svg>
              </div>
              <p class="info-text-title">Allergies:</p>
              <div class="header-action-icons">
                <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
                  <img src="@/assets/cardActions/pin.svg" alt="Pin" />
                </div>
                <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
                  <img src="@/assets/cardActions/unpin.svg" alt="Unpin" />
                </div>
              </div>
            </div>

            <!-- Content: allergies list -->
            <div class="allergy-content">
              <div v-if="displayAllergies.length > 0" class="allergies-list">
                <div
                  v-for="allergy in displayAllergies"
                  :key="allergy.id || allergy.allergen"
                  class="allergy-item"
                >
                  <div class="allergy-name-row">
                    <p class="allergy-name-title">{{ allergy.allergen }}</p>
                    <span v-if="allergy.severity" class="severity-tag" :class="allergy.severity.toLowerCase()">{{ formatSeverity(allergy.severity) }}</span>
                  </div>
                  <p class="info-text-allergy-info-text" v-if="allergy.reactions">
                    Reactions: {{ allergy.reactions }}
                  </p>
                </div>
              </div>
              <div v-else class="empty-state">
                <p class="info-text">There are no allergies recorded for this patient yet.</p>
              </div>
            </div>
          </div>
          </div>
          <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
            <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
              <template #prefix>
                <img src="@/assets/cardActions/move.svg" alt="Move" />
              </template>
            </FoldableButton>
            <div class="flex flex-row gap-1 justify-end">
              <FoldableButton v-show="false" text="Reconcile" @click="handleReconcile">
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M14.625 11.235C14.61 11.235 14.6025 11.235 14.5875 11.2425C14.4 9.975 13.32 9 12 9C10.95 9 10.05 9.6225 9.63 10.515C8.445 10.575 7.5 11.55 7.5 12.75C7.5 13.995 8.505 15 9.75 15L14.625 14.985C15.66 14.985 16.5 14.145 16.5 13.11C16.5 12.075 15.66 11.235 14.625 11.235ZM14.6325 13.5H9.75C9.3375 13.5 9 13.1625 9 12.75C9 12.3375 9.3375 12 9.75 12H10.6875V11.8125C10.6875 11.085 11.2725 10.5 12 10.5C12.7275 10.5 13.3125 11.085 13.3125 11.8125V12.75C13.3125 12.75 14.625 12.75 14.6325 12.75C14.8425 12.75 15.0075 12.915 15.0075 13.125C15 13.3275 14.835 13.5 14.6325 13.5ZM6 3.195V4.7625C4.2525 5.385 3 7.0425 3 9C3 10.3275 3.585 11.505 4.5 12.33V10.5H6V15H1.5V13.5H3.5475C2.295 12.405 1.5 10.8 1.5 9C1.5 6.2025 3.4125 3.8625 6 3.195ZM13.5 4.5H11.4525C12.525 5.445 13.26 6.7575 13.4475 8.25H11.9325C11.76 7.23 11.235 6.3375 10.5 5.67V7.5H9V3H13.5V4.5Z" fill="#374957"/>
                  </svg>
                </template>
              </FoldableButton>
              <FoldableButton text="Add new" @click="handleAddNew">
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M7 1V13M1 7H13" stroke="#1E4670" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </template>
              </FoldableButton>
              <FoldableButton text="Edit" @click="handleEdit">
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1727 2.37431C14.3169 2.59265 14.2928 2.88936 14.1006 3.08157L7.20634 9.97586C7.13567 10.0465 7.04744 10.0971 6.95075 10.1224L4.07942 10.8724C3.98578 10.8968 3.88924 10.8963 3.79854 10.8732C3.70212 10.8487 3.61229 10.7986 3.53953 10.7259C3.39832 10.5846 3.34257 10.3792 3.39304 10.1859L4.14304 7.31463C4.16514 7.23002 4.20661 7.14646 4.26397 7.08091L11.1838 0.164752C11.2444 0.10418 11.3174 0.0588451 11.3968 0.0312234C11.4556 0.0107432 11.518 0 11.5816 0C11.7307 0 11.8738 0.0592631 11.9793 0.164752L14.1006 2.28607C14.1281 2.31353 14.1521 2.34312 14.1727 2.37431ZM12.9074 2.68382L11.5816 1.358L5.19294 7.74662L4.7242 9.54119L6.51877 9.07244L12.9074 2.68382Z" fill="#374957"/>
                    <path d="M12.8126 11.1827C13.0176 9.42952 13.0829 7.66408 13.0083 5.90309C13.0047 5.81878 13.0364 5.73674 13.0961 5.67706L13.8336 4.93957C13.9243 4.84889 14.0792 4.90646 14.0877 5.03441C14.2264 7.12665 14.1738 9.22839 13.93 11.3134C13.7525 12.8303 12.5343 14.0191 11.0253 14.1877C8.42532 14.4783 5.73782 14.4783 3.13788 14.1877C1.62884 14.0191 0.410592 12.8303 0.233178 11.3134C-0.0777259 8.6552 -0.0777259 5.9698 0.233178 3.31157C0.410592 1.79467 1.62884 0.605917 3.13789 0.437259C5.1102 0.216824 7.1329 0.163611 9.12955 0.277621C9.25823 0.284969 9.31689 0.440681 9.22575 0.53182L8.48134 1.27624C8.42231 1.33526 8.34138 1.36695 8.25796 1.36414C6.58814 1.30782 4.90697 1.37154 3.26284 1.5553C2.26526 1.66679 1.46615 2.454 1.35056 3.44226C1.04981 6.01365 1.04981 8.61134 1.35056 11.1827C1.46615 12.171 2.26526 12.9582 3.26284 13.0697C5.77973 13.351 8.38341 13.351 10.9003 13.0697C11.8979 12.9582 12.697 12.171 12.8126 11.1827Z" fill="#374957"/>
                  </svg>
                </template>
              </FoldableButton>
              <FoldableButton text="Variable Properties" @click="handleVariableProperties">
                <template #prefix>
                  <img src="@/assets/cardActions/pt_variable.svg" alt="Variable Properties" />
                </template>
              </FoldableButton>
              <FoldableButton v-show="false" text="Send to">
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none">
                    <path d="M0 12V0L14.25 6L0 12ZM1.5 9.75L10.3875 6L1.5 2.25V4.875L6 6L1.5 7.125V9.75Z" fill="#374957"/>
                  </svg>
                </template>
              </FoldableButton>
            </div>
          </div>
      </div>
    </transition>

    <PatientVariableDialog
      v-model:visible="showPtVariablesDialog"
      :ptVariables="ptVariables"
      :patientId="patientId"
    />
  </template>
  <script setup>
  import { ref, computed } from 'vue'
  import { useMyPatientsStore } from '@/store/helpers'
  import { useCardActions } from '@/composables/useCardActions'
  import PatientVariableDialog from './PatientVariableDialog.vue'

  // Define props
  const props = defineProps({
    patient: {
      type: String,
      default: ''
    },
    cardData: {
      type: Object,
      default: () => ({})
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    context: {
      type: String,
      default: 'pegboard'
    },
    allergies: {
      type: Array,
      default: () => []
    },
    externalVariableDialog: {
      type: Boolean,
      default: false
    }
  })

  // Define emits
  const emit = defineEmits(['pin-card', 'unpin-card', 'add-new', 'edit', 'reconcile', 'open-variable-dialog'])

  const { patientInfoStore } = useMyPatientsStore()

  // Use the card actions composable
  const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit)

  // Patient variable dialog
  const ptVariables = ['pt_allergies']
  const showPtVariablesDialog = ref(false)
  const patientId = computed(() => props.patient || '')

  const handleVariableProperties = () => {
    if (!props.externalVariableDialog) {
      showPtVariablesDialog.value = true
    }
    emit('open-variable-dialog', ptVariables)
  }

  const isLeaving = ref(false);


  const startUnpin = () => {
    if(props.showFooter){
      isLeaving.value = true; // triggers the leave animation
    } else {
      handleUnpinCard()
    }
  };


  // This is called after the leave animation finishes
  const afterLeave = () => {
    emit('unpin-card', props.cardData); // parent removes the card
  };


  const expanded = ref({
    allergy: true,
  })

  const toggleCard = (cardType) => {
    expanded.value[cardType] = !expanded.value[cardType]
  }

  // Display allergies - prioritize props.allergies (from parent) over store data
  const displayAllergies = computed(() => {
    // If allergies prop is provided and has items, use it
    if (props.allergies && props.allergies.length > 0) {
      return props.allergies;
    }
    // Otherwise fall back to store data
    const storeData = patientInfoStore.getters.getAllergyCardData(props.patient);
    if (storeData && Array.isArray(storeData) && storeData.length > 0) {
      return storeData;
    }
    // If storeData is a string (legacy format), return empty array
    if (storeData && typeof storeData === 'string' && storeData !== 'N/A') {
      return [{ allergen: storeData }];
    }
    return [];
  });

  // Format severity for display
  const formatSeverity = (severity) => {
    const severityMap = {
      'mild': 'Mild',
      'moderate': 'Moderate',
      'severe': 'Severe'
    };
    return severityMap[severity] || severity;
  };

  // Handle add new button click
  const handleAddNew = () => {
    emit('add-new');
  };

  // Handle edit button click - opens the allergy list dialog
  const handleEdit = () => {
    emit('edit');
  };

  // Handle reconcile button click
  const handleReconcile = () => {
    emit('reconcile');
  };

</script>
  
  
  <style scoped>
  
  /* Expanded card footer visibility with hover expand animation */
  .card-expand {
    display: flex;
    align-items: center;
    gap: 16px;
    /* animation base state */
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    padding-top: 0;
    margin-top: 0;
    border-top: 1px dashed var(--DividerGray, #C4C4C4);
    border-top-color: transparent;
    pointer-events: none;
    transition: max-height 300ms linear,
                opacity 300ms linear,
                padding-top 300ms linear,
                padding-bottom 300ms linear,
                margin-top 300ms linear,
                border-top-color 300ms linear;
  }

  .info-card.expanded:hover .card-expand {
    /* ensure enough room for actions */
    max-height: 80px;
    opacity: 1;
    padding-top: 10px;
    padding-bottom: 4px;
    margin-top: 10px;
    border-top-color: var(--DividerGray, #C4C4C4);
    pointer-events: auto;
  }
  
  .pin-toggle {
    position: relative;
    cursor: pointer;
  }
  
  .pin-toggle .icon {
    position: absolute;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  
  .pin-toggle .unpin {
    opacity: 0;
    transform: scale(0.8);
  }
  
  /* Hover effect */
  .pin-toggle:hover .pin {
    opacity: 0;
    transform: scale(1);
  }
  
  .pin-toggle:hover .unpin {
    opacity: 1;
    transform: scale(1);
  }
  
  
  .unpin-slide-leave-active {
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
                opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .unpin-slide-leave-to {
    transform: translateX(-100%) scale(0.95);
    opacity: 0;
  }
  
  .peg-board-title {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 16px;
  }
  
  .peg-board-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow-y: auto;
    padding: 0 8px;
  }
  
  .info-card {
    background-color: white;
    border-radius: 5px;
    padding: 12px 16px;
    box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
  }
  
  .info-card-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
  }
  
  .info-card-content-col-group {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 8px;
  }
  
  .info-row-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-grow: 1;
  }
  
  .info-row {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .icon-container {
    background-color: #f2f2f2;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .icon-style {
    width: 20px;
    height: 20px;
  }
  
  .info-text {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0.25px;
    line-height: 20px;
  }
  
  .action-icons {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .action-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  
  .appointment-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 50px;
    height: 64px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
    overflow: hidden;
  }
  
  .month {
    background-color: #004879;
    color: white;
    width: 100%;
    text-align: center;
    padding: 2px 0;
    font-size: 14px;
  }
  
  .day {
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    text-transform: capitalize;
    height: 24px;
  }
  
  .weekday {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1;
    padding-bottom: 3px;
  }
  
  .appointment-details {
      flex-grow: 1;
  }
  
  .detail-title {
      font-size: 12px;
      color: #666;
  }
  .detail-text {
      font-size: 14px;
      color: #333;
      margin-bottom: 4px;
  }
  .action-icons-appointment {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding-top: 20px;
  }
  .info-text-title {
      font-family: 'Inter', sans-serif;
      font-size: 12px;
      color: #666;
  }
  .info-text-large {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      color: #333;
      font-weight: 500;
  }
  
  /* Badge for billing preference */
  .badge {
    color: #25B8C2;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px; /* 120% */
    letter-spacing: 0.25px;
    display: flex;
    padding: 4px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
  }
  
  .badge-default {
    border-radius: 20px;
    background: #EBFFF8;
    width: 68px;
  }
  
  .expand-action {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #1B79A0;
    cursor: pointer;
    padding: 4px 10px;
    border-radius: 5px;
  }
  
  .expand-action span {
    color: var(--color-Darkblue-000, #1E4670);
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
  
  
  .action-icon {
    width: 28px;          /* w-7 */
    height: 28px;         /* h-7 */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;   /* rounded-[5px] */
    padding: 5px;         /* pd-5 (assuming you meant padding) */
    cursor: pointer;
    transition: background-color 0.2s; /* duration-200 transition-colors */
  }
  
  .action-icon:hover,
  .expand-action:hover {
    background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
  }

  /* Allergy card expanded state */
  .allergy-card-expanded {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    flex: 1;
  }

  /* Header row: icon + title + pin */
  .allergy-header {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .allergy-header .info-text-title {
    flex: 1;
  }

  .header-action-icons {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-left: auto;
  }

  .allergy-content {
    margin-left: 32px;
  }

  /* Expand buttons - icon only, expand on hover */
  .add-new-expand,
  .reconcile-expand,
  .variable-expand,
  .edit-expand,
  .send-expand {
    display: flex;
    align-items: center;
    width: 26px;
    overflow: hidden;
    padding: 4px;
    justify-content: center;
    transition: width 0.25s ease, padding 0.25s ease, gap 0.25s ease;
    gap: 0;
  }

  .add-new-expand:hover,
  .reconcile-expand:hover,
  .variable-expand:hover,
  .edit-expand:hover,
  .send-expand:hover {
    padding: 4px 10px;
    justify-content: flex-start;
    gap: 6px;
  }

  .add-new-expand:hover { width: 92px; }
  .reconcile-expand:hover { width: 110px; }
  .variable-expand:hover { width: 160px; }
  .edit-expand:hover { width: 74px; }
  .send-expand:hover { width: 90px; }

  .add-new-expand span,
  .reconcile-expand span,
  .variable-expand span,
  .edit-expand span,
  .send-expand span {
    white-space: nowrap;
    opacity: 0;
    min-width: 0;
    transition: opacity 0.2s ease;
    transition-delay: 0.05s;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    color: #1E4670;
    text-decoration: underline;
  }

  .add-new-expand:hover span,
  .reconcile-expand:hover span,
  .variable-expand:hover span,
  .edit-expand:hover span,
  .send-expand:hover span {
    opacity: 1;
  }

  .add-new-expand svg,
  .reconcile-expand svg,
  .variable-expand img,
  .edit-expand svg,
  .send-expand svg {
    flex-shrink: 0;
  }

  /* Move expand button */
  .move-expand {
    display: flex;
    align-items: center;
    width: 26px;
    overflow: hidden;
    padding: 4px;
    justify-content: center;
    transition: width 0.4s ease, padding 0.4s ease, gap 0.4s ease;
    gap: 0;
  }

  .move-expand:hover {
    padding: 4px 10px;
    justify-content: flex-start;
    gap: 6px;
    width: 78px;
  }

  .move-expand span {
    white-space: nowrap;
    opacity: 0;
    min-width: 0;
    transition: opacity 0.3s ease;
    transition-delay: 0.1s;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    color: #1E4670;
    text-decoration: underline;
  }

  .move-expand:hover span {
    opacity: 1;
  }

  .move-expand img {
    flex-shrink: 0;
  }

  .info-text-allergy-info-text {
    color: var(--SecondaryBlack, #666);
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0.1px;
    padding-left: 8px;
  }

  .allergy-name-row {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .severity-tag {
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.5px;
    display: flex;
    padding: 0 6px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 20px;
    white-space: nowrap;
  }

  .severity-tag.severe {
    color: var(--ErrorRed, #D10000);
    background: #F6CCCC;
  }

  .severity-tag.moderate {
    color: #F06539;
    background: var(--warning-yellow-medium-bg, #F7EECE);
  }

  .severity-tag.mild {
    color: #25B8C2;
    background: #E3F8F9;
  }

  /* Allergies List */
  .allergies-list {
    display: flex;
    flex-direction: column;
    gap: 0;
    max-height: 130px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 4px;
    width: 100%;
  }

  .allergy-item {
    width: 100%;
    flex-shrink: 0;
    border: none;
    background-color: white;
    padding: 2px 0;
  }

  /* Scrollbar styling - overlay style */
  .allergies-list::-webkit-scrollbar {
    width: 0px;
  }

  .allergies-list:hover::-webkit-scrollbar {
    width: 4px;
  }

  .allergies-list::-webkit-scrollbar-track {
    background: transparent;
  }

  .allergies-list::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }

  .allergies-list::-webkit-scrollbar-thumb:hover {
    background: #999;
  }

  .allergy-name-title {
    overflow: hidden;
    color: var(--TrueBlack, #333);
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    align-self: stretch;
  }

  .empty-state {
    padding: 8px 0;
    text-align: center;
    color: #999999;
    font-style: italic;
    margin-left: -32px;
  }

  /* Fix action-icons to stay in position */
  .action-icons {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-shrink: 0;
  }

  /* Fix flex-1 width constraint */
  .flex-1 {
    flex: 1;
    min-width: 0;
  }

  /* unified pin toggle */
  .pin-toggle { position: relative; cursor: pointer; }
  .pin-toggle .icon { position: absolute; transition: opacity 0.3s ease, transform 0.3s ease; }
  .pin-toggle .unpin { opacity: 0; transform: scale(0.8); }
  .pin-toggle:hover .pin { opacity: 0; transform: scale(1); }
  .pin-toggle:hover .unpin { opacity: 1; transform: scale(1); }

  </style>
  